import { Button } from '@mui/material';
import React, { FC, useState, useEffect } from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { IEntityContentField } from '../../../lib/interfaces/Common';
import JSCodeResult from '../CodeEditor/CodeResult/JSCodeResult';
import ContentRenderer from '../Content/ContentRenderer';
import JsOnlyResult from './JsOnlyResult';
import './JsOnlyRenderer.scss';

type jsOnlyRendererProps = {
	js: string;
	jsCodeExample: string;
	field: IEntityContentField;
};

const JSonlyRenderer: FC<jsOnlyRendererProps> = ({
	js,
	jsCodeExample,
	field,
}) => {
	const [jsCodeValue, setJsCodeValue] = useState('');
	const [jsResults, setJsResults] = useState(null);
	const runCode = async () => {
		setJsCodeValue(js);
	};
	useEffect(() => {
		window.addEventListener('message', (e) => {
			const { data } = e;
			if (data && data.source && data.source === `__cwt__jstests__${field.name}`) {
				setJsResults(data.payload);
			}
		});
	}, []);
	const jsIframe = React.useMemo(
		() => (
			<div className="code-result">
				<JSCodeResult
					code={jsCodeValue}
					field={field}
					isHorizontalView
					editorsNumber={1}
					hideIframe
					name={field.name}
					isCodeExample
					// isJsOnlyCodeExample
				/>
			</div>
		),
		[jsCodeValue],
	);
	return (
		<div className="JsOnlyRenderer">
			<div className="JsOnlyRenderer__code-example">
				<div className="JsOnlyRenderer__header">
					<Button
						startIcon={<PlayArrowIcon />}
						onClick={runCode}
						sx={{ marginRight: '20px' }}
					>
						Run code
					</Button>
				</div>
				<ContentRenderer html={jsCodeExample} />
			</div>
			<div className="JsOnlyRenderer__code-result">
				<div className="JsOnlyRenderer__header">Output</div>
				{jsIframe}
				{jsResults && <JsOnlyResult evaluatedResult={jsResults} />}
			</div>
		</div>
	);
};

export default JSonlyRenderer;
